import { darken, lighten } from "polished";
import { css } from "styled-components";

export const colors = {
  white: "#FFFFFF",
  black: "#252525",
  navy: "#1B2136",
  lightSecondary: "#747474",
  cyan: "#07ADF5",
  lightBlue: "#0082FB",
  blue: "#2E70ED",
  hoverVividBlue: "#005AC5",
  darkerBlue: "#0147CC",
  hoverDarkerBlue: "#003BA9",
  vividBlue: "#006DED",
  green: "#69F590",
  lavender: "#919DC8",
  backgroundLightBlue: "#F7F8FC",
  sectionBorder: "#EDEDED",
  lightBorder: "#E4E4E4",
  hoverBorder: "#d0d0d0",
  negative: "#D04040",
  positive: "#2AA663",
  lightNegative: "#FA6464",
  lightPositive: "#69F590",
  blueGradient: css`
    background: linear-gradient(89deg, #2f63f3 21.14%, #00c2ff 68.45%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `,
  chart: {
    grid: "#F0F0F0",
    gray: "#D9D9D9",
    blue: "#85DCF9",
    dot: lighten(0.1, "#252525"),
    barHover: darken(0.25, "#85DCF9"),
    bottomBarHover: darken(0.25, "#D9D9D9"),
    darkBlue: "#011A9B",
    pink: "#FB5BCE",
    murple: "#740D99",
    orange: "#EB9D42",
    lightGray: "#F3F3F3",
    green: "#11A104",
    lightGreen: "#9DF595",
  },
};
